// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"623166b2","605":"2166ce2a","809":"62452d41","981":"9b41e597"}[chunkId] + ".chunk.js";
};